
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/FutureTechVirtualCareerFair",
      function () {
        return require("private-next-pages/FutureTechVirtualCareerFair.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/FutureTechVirtualCareerFair"])
      });
    }
  